






import { Component, Vue } from 'vue-property-decorator'
import  storyListCom from '@/views/manage/tenantStory/template/storyList/storyListCom.vue'

@Component({
  name: '',
  components: {
    storyListCom
  }
})
export default class extends Vue {
   dataObj = {
    getListUrl: '/blackcat/story/line/user/list',
    directUrl: 'userStoryDetail',
    onLineType: 'userOnline'
  }
}
